// Main以下で使うこと
export const uiHeight = (adjustment?) => {
  if (adjustment) {
    return `calc(100vh + ${adjustment}px)`;
  }
  return `calc(100vh - 56px)`;
};
